import SchoolInactiveScreen from '../../src/screens/auth/SchoolInactiveScreen';

export default SchoolInactiveScreen;
